import { Component, Input } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { EnvSetting } from 'projects/Autofacets-Core/src/app/utils/env-setting';

@Component({
  selector: 'app-modal-dialog',
  templateUrl: './modal-dialog.component.html'
})
export class ModalDialogComponent {
    @Input() modelBody: any;
    @Input() modelHeader: any;
    currentLang:string;
    closeResult: string;
    constructor(public activeModal: NgbActiveModal,
        private modalService: NgbModal,
        private translate: TranslateService,
        private cookieservice: CookieService) {
            if (this.isCookiesExist()) {
                    this.currentLang = this.cookieservice.get('userSelectedLanguage');
                  } else {
                    this.currentLang = EnvSetting.LANGUAGE_CONFIG.defaultLanguage;
                  }
                  this.translate.use(this.currentLang);
        }
        private isCookiesExist(): boolean {
            return this.cookieservice.check('userSelectedLanguage');
          }
     // Open default modal
     open(content) {
        this.modalService.open(content).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        });
    }

    // This function is used in open
    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    // Open modal with dark section
    openModal(customContent) {
        this.modalService.open(customContent, { windowClass: 'dark-modal' });
    }
}
